var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaderboard-list"},_vm._l((_vm.entries),function(entry){return _c('Leaderboard_Entry',{key:entry.position,attrs:{"data":entry,"displayType":_vm.displayType,"highlighted":_vm.isMe(entry.slug)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }